import RequestAbstract from "../abstract";

export default class MerchantInvites extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/merchant-invites";
    }
}
